/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The version of this API. This is for technical purposes only.
 */
export const VersionSalesBridgeCommonServicesApi = {
  _011: '0.1.1',
} as const;
export type VersionSalesBridgeCommonServicesApi =
  (typeof VersionSalesBridgeCommonServicesApi)[keyof typeof VersionSalesBridgeCommonServicesApi];
